import React, { useState } from 'react';
import { Select, Spin, Input, Divider } from 'antd';
import moment from 'moment'
import axios from 'axios';


const { Option } = Select;

class SelectWithFetch extends React.Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
  }

  state = {
    data: [],
    value: [],
    fetching: false,
  };


  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.custVal && nextProps.custVal != null){
        return {
           value: nextProps.custVal
        }
    }
    return null
  }


  handleChange = value => {
    if(value){
    let val = value;
    this.props.setSelectedResult(value)
      this.setState({
        value : val,
        data: [],
        fetching: false,
      });

    }else{
      if(this.props.form){
        this.props.form.resetFields()
      }
      this.setState({
        value,
        data: [],
        fetching: false,
      });
    }
  };


  render() {
    const { value } = this.state;

    return (
      <Select
         mode={ this.props.type == 'multi' ? "multiple" : ''}
        // loading={this.props.loading ? this.props.loading : false}
        notFoundContent={this.props.loading == true ? <Spin size="small" /> : null}
        showSearch
        showArrow={false}
        labelInValue
        size={this.props.size ? this.props.size :'middle'}
        value={value}
        placeholder={this.props.placeholder ? this.props.placeholder : 'Search'}
        filterOption={false}
        onSearch={(val)=>{
          if( this.props.handleSearch){
            this.props.handleSearch(val)
          }
        }}
        onChange={this.handleChange}
        style={{ width: '100%' }}
        dropdownRender={menu => (
          <div>
            {menu}
            {
              this.props.dropDownEnabled && this.props.dropDownEnabled == true && 
              <>
              {this.props.dropDownComp && this.props.dropDownComp}
              </>
            }
          </div>
        )}
      >
        {this.props.data.map(d => {

          let keyName = null;
          if(this.props.keyName ){
            keyName = d[this.props.keyName]
          }
    
          return(
            <Option key={keyName} value={keyName}>{this.props.fields.map((item)=>{
                return(
                  `${item.title == null ? '' : item.title} ${item.title == null ? '' : ':'} ${d[item.val]}`
                )
              }).join(' ')}</Option>
            )
          
          })}
    
      </Select>
    );
  }
}

export default SelectWithFetch